import type { KeyboardScope } from "../enums/shell";
import { KEYBOARD_SCOPE } from "../enums/shell";

type Binding = {
  combo: string;
  scope: KeyboardScope;
  run: () => void;
  describe: string;
};

const bindings: Binding[] = [];

export function registerBinding(binding: Binding): () => void {
  bindings.push(binding);
  return () => {
    const index = bindings.indexOf(binding);
    if (index !== -1) {
      bindings.splice(index, 1);
    }
  };
}

export function bindingsFor(scope: KeyboardScope): Binding[] {
  return bindings.filter(
    (binding) =>
      binding.scope === KEYBOARD_SCOPE.GLOBAL || binding.scope === scope,
  );
}

export function allBindings(): Binding[] {
  return [...bindings];
}
